class StalePromiseFilter {
  constructor() {
    this._counter = 0;

    this.swallowOwnRejections = this.swallowOwnRejections.bind(this);
  }

  cancel() {
    this._counter++;
  }

  ownsRejectionValue(x) {
    return x === 'stale';
  }

  run(promiseFactory) {
    this._counter++;
    let snapshot = this._counter;

    return promiseFactory()
      .then(x => {
        if (snapshot !== this._counter) {
          return Promise.reject('stale');
        }

        return x;
      });
  }

  swallowOwnRejections(x) {
    if (!this.ownsRejectionValue(x)) {
      return Promise.reject(x);
    }
  }
}

export default StalePromiseFilter;
